module.exports = __webpack_public_path__ + "static/img/bg2.a84191f8.png";